export default "__VITE_ASSET__hOjLOKbt__"